<template>
  <b-field :label="label"
          :type="typeSiErreur"
          :message="messageIban">
    <b-input
      v-model="ibanValue"
      :size="size"></b-input>
  </b-field>
</template>

<script>
import IBAN from 'iban';
import gestionType from '@/services/general/gestionType';
import ibanFormater from '@/services/general/ibanFormater';

export default {
  name: 'input-iban',
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    size: {
      type: String,
    },
  },
  computed: {
    ibanValue: {
      get() {
        return ibanFormater(this.value);
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    typeSiErreur() {
      return gestionType(!this.value
        || IBAN.isValid(this.value), true);
    },
    messageIban() {
      if (this.value && !IBAN.isValid(this.value)) {
        return this.$i18n.t('editionClient.validation.iban');
      }
      return '';
    },
  },
};
</script>
<style lang="scss">
</style>
